<template>
  <sub-section
    title="Your State Pension"
    helpTitle="Your State Pension"
    :helpText="htmlArray('haves.state-pension.help')"
  >
    <div class="row">
      <div class="d-flex align-items-center">
        <p class="text-muted align-middle mb-0">
          {{ statePensionText }}
        </p>
      </div>
      <div v-if="isOverSPA" class="mt-3 text-center">
        <button
          type="button"
          class="btn btn-outline-secondary btn-sm"
          @click="onEditClicked($event)"
        >
          <span class="d-none d-sm-inline-block">Edit state pension</span>
        </button>
      </div>
    </div>
  </sub-section>

  <modal
    title="State Pension"
    ref="statePensionModal"
    idKey="statePensionModal"
    close-button-aria-label="Close State Pension popup editor"
  >
    <state-pension-editor
      ref="statePensionEditor"
      @edit-finished="onEditFinished"
    />
  </modal>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import Modal from "@/guiide/components/common/Modal.vue";
import SubSection from "@/guiide/components/common/SubSection.vue";
import StatePensionEditor from "@/guiide/components/assets/StatePensionEditor.vue";
import { retireeDescriber } from "@/guiide/ts/retireeDescriber";
import { useUIContent } from "@/guiide/ts/configuration/useUIContent";

export default defineComponent({
  name: "StatePensionViewer",
  components: {
    SubSection,
    Modal,
    StatePensionEditor
  },
  setup() {
    const statePensionModal = ref(null);
    const statePensionEditor = ref(null);
    const { htmlArray } = useUIContent();

    return {
      statePensionModal,
      statePensionEditor,
      htmlArray
    };
  },
  computed: {
    statePensionText() {
      return retireeDescriber.statePensionDescription().description;
    },
    isOverSPA: function(): boolean {
      return this.$store.state.retiree?.statePension.isOverSPA ?? false;
    },
    userHasDefinedAmount: function(): boolean {
      const actualAmount = this.$store.state.retiree?.statePension.actualAmount;
      return !(actualAmount == null || actualAmount == 0);
    }
  },
  methods: {
    onEditClicked(event) {
      event.preventDefault();

      let amount = null;
      if (this.userHasDefinedAmount) {
        amount = this.$store.state.retiree?.statePension.actualAmount;
      }

      this.statePensionEditor.setValues(amount);
      this.statePensionModal.showModal();
    },
    onEditFinished() {
      this.statePensionModal.closeModal();
    }
  }
});
</script>
